export const mdiCodeDropdownSchema = {
	title: 'MDI Code Dropdown Schema',
	description: 'MDI Code Dropdown Schema',
	version: 1,
	primaryKey: 'sfid',
	type: 'object',
	properties: {
		sfid: { type: 'string', primary: true, maxLength: 200 },
		mdicode_c: { type: 'string' },
		cluster_c: { type: 'string' },
		cluster_name_c: { type: 'string' },
	},
	required: ['sfid', 'mdicode_c', 'cluster_c', 'cluster_name_c'],
};
